import "es6-shim";
import "reflect-metadata";
import { enableProdMode } from "@angular/core";
import "intl";
import "intl/locale-data/jsonp/en.js";
require("angular2-ie9-shims/shims_for_IE.prod");
require("core-js/client/shim");
require("zone.js/dist/zone");

enableProdMode();



// WEBPACK FOOTER //
// ./src/polyfills.ts